/**
 * Smarter parser that handles ISO and DD/MM/YYYY formats
 */
export const smartParseDate = (dateString: string | undefined | null): Date | null => {
  if (!dateString) return null

  // Try to handle DD/MM/YYYY or DD-MM-YYYY format using a Regex
  // Matches: 27/02/2025 or 27-02-2025 (optionally with time)
  const ddmmyyyyRegex = /^(\d{1,2})[/-](\d{1,2})[/-](\d{4})(.*)$/
  const match = dateString.trim().match(ddmmyyyyRegex)

  if (match) {
    const day = parseInt(match[1], 10)
    const month = parseInt(match[2], 10) - 1 // JS months are 0-indexed
    const year = parseInt(match[3], 10)

    // Check if there is time attached (e.g., " 09:55")
    const timePart = match[4].trim()
    if (timePart) {
      const [hours, minutes, seconds] = timePart.split(':').map((n) => parseInt(n, 10) || 0)
      return new Date(year, month, day, hours, minutes, seconds || 0)
    }

    return new Date(year, month, day)
  }

  // Fallback to native ISO parsing for YYYY-MM-DD
  const timestamp = Date.parse(dateString)
  return isNaN(timestamp) ? null : new Date(timestamp)
}

/**
 * Updated ISO Parser using the smart logic
 */
export const parseIsoDate = (datestring: string): string => {
  const d = smartParseDate(datestring)
  return d ? dateTostring(d) : ''
}

export const parseIsoDateTime = (datestring: string): string => {
  const d = smartParseDate(datestring)
  return d ? dateTimeToString(d) : ''
}

export const dateTimeToString = (time: Date): string => {
  const year = time.getFullYear().toString()
  const month = (time.getMonth() + 1).toString().padStart(2, '0')
  const day = time.getDate().toString().padStart(2, '0')

  const h = time.getHours().toString().padStart(2, '0')
  const i = time.getMinutes().toString().padStart(2, '0')
  const s = time.getSeconds().toString().padStart(2, '0')

  return `${year}-${month}-${day} ${h}:${i}:${s}`
}

export const dateTostring = (time: Date): string => {
  const year = time.getFullYear().toString()
  const month = (time.getMonth() + 1).toString().padStart(2, '0')
  const day = time.getDate().toString().padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const cleanHtml = (html: string): string => {
  html = html.replace(/(<\/?(?:a|p|img|br)[^>]*>)|<[^>]+>/gi, '$1')
  return html
}

export const nl2br = (text: string): string => {
  return text.replace(/(?:\r\n|\r|\n)/g, '<br>')
}
